// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oC0I","col":"styles_col__115SF"};